module.exports = __webpack_public_path__ + "media/images/emblems/Courrendlin-81404f471987d65c68d5b1b33480a614.png";